<template>
	<div>
		<div class="row">
			<div class="col-sm-4">
				<md-field id="inputField">
					<md-input v-model="textNewValue" :placeholder="`New ${columnTitle}`" @input="textNewValue = sanitizeInput($event)"></md-input>
				</md-field><br />
			</div>
			<div class="col-sm-8">
				<div class="button-section button-section-style">
					<md-button class="md-raised md-accent md-white-color capitalize" @click="addNewValue()">Add New {{ columnTitle }}</md-button>
				</div>
			</div>
		</div>

		<md-table class="member-table">
			<md-table-row>
				<md-table-head class="card-header">{{ columnTitle }}s
					<img src="https://storage.googleapis.com/protopia/app/web/down-arrow.png" v-if="sortOrder == -1" @click="sortColumn()">
					<img src="https://storage.googleapis.com/protopia/app/web/up-arrow.png" v-if="sortOrder == 1" @click="sortColumn()">
				</md-table-head>
				<md-table-head class="card-header"> Actions </md-table-head>
			</md-table-row>

			<configuration-edit-row
					v-for="(val, idx) in customValues"
					class="md-table-row"
					v-bind:key="`values-${idx}`"
					:title="columnTitle"
					:index="idx"
					:label="val"
					:inputType="inputType"
					@update="update"
					@remove="remove">
			</configuration-edit-row>

			<template v-if="customValues.length == 0">
				<tr>
					<td colspan="3" align="center">
						<md-empty-state class="table-no-record" md-label="No Record Found" md-description="">
						</md-empty-state>
					</td>
				</tr>
			</template>
		</md-table>
	</div>
</template>
<script>
import API from "../services/API";
import { sanitizeInput } from '../utils/sanitizer';
import ConfigurationEditRow from "./ConfigurationEditRow";
export default {
	name: "configurationEditor",
	props: ['configKey', 'columnTitle', 'inputType'],
	components: {
		ConfigurationEditRow
	},
	data() {
		return {
			api: new API(),
			customValues: [],
			textNewValue: "",
			sortOrder: 1
		}
	},
	watch: {
		$route: "loadData"
	},
	created() {
		this.loadData();
	},
	methods: {
		loadData: async function () {
			this.api.get(`configuration/customizations/${this.configKey}`).then(async customizations => {
				if (customizations.data) {
					this.customValues = customizations.data.values.filter(i => (i != undefined && i != ""));
				}
			});
		},
		sortColumn() {
			this.sortOrder = -1 * this.sortOrder;
			this.customValues.sort((a, b) => a > b ? this.sortOrder : (-1 * this.sortOrder));
		},
		addNewValue() {
			if (this.textNewValue.length > 1) {
				const sanitizedValue = this.sanitizeInput(this.textNewValue);
				this.customValues.push(sanitizedValue);
				this.customValues.sort((a, b) => a > b ? this.sortOrder : (-1 * this.sortOrder));
				this.save();
				this.textNewValue = "";
			}
		},
		update(idx, value) {
			if (value.length > 0) {
				this.customValues[idx] = this.sanitizeInput(value);
				this.save();
			} else {
				this.remove(idx);
			}
		},
		remove(idx) {
			this.customValues.splice(idx, 1);
			this.save();
		},
		save() {
			let arrayToSave = this.customValues.sort();
			this.api.post(`configuration/customizations/`, {key: this.configKey, values: arrayToSave}).then(() => {
				console.log("Saved", this.configKey, "values:", arrayToSave);
			});
		},
		sanitizeNewValue(value) {
			this.textNewValue = sanitizeInput(value);
		},
		sanitizeInput(input) {
			return sanitizeInput(input);
		},
		
	}
}
</script>


// WEBPACK FOOTER //
// src/components/ConfigurationEditor.vue